// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"styles_linkContainer__3GGL0","linkWrapper":"styles_linkWrapper__3iQGx"};